export default {
  methods: {
    beforeWindowUnload(event) {
      if (this.dirty) {
        // Cancel the event as stated by the standard.
        event.preventDefault();
        // Chrome requires returnValue to be set.
        event.returnValue = "";
      }
    },
  },
};
